import axios from 'axios';

import { HUB_URL_AUTH } from '../config';
import { restoreSettings } from './settings';

const source = axios.CancelToken.source();

const instance = axios.create({
  baseURL: HUB_URL_AUTH,
  cancelToken: source.token,
});

instance.interceptors.request.use(config => {
  const settings = restoreSettings() || {};
  const runtimeBaseUrl =
    settings.hubUrlAuth || settings.HUB_URL_AUTH || HUB_URL_AUTH || '';

  if (runtimeBaseUrl) {
    config.baseURL = runtimeBaseUrl;
  }

  return config;
});

export default instance;
